import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { JwtService } from '@shared/services/jwt.service';
import { Observable, ReplaySubject } from 'rxjs';
import { WebAppEnvironment } from './WebAppEnvironment';


@Injectable({ providedIn: 'root' })
export class EnvironmentService implements OnDestroy {

    private _current: WebAppEnvironment;
    private _afterLoad$: ReplaySubject<WebAppEnvironment> = new ReplaySubject<WebAppEnvironment>();

    constructor(private _http: HttpClient, private _jwt: JwtService) {
        this._http.get<WebAppEnvironment>('/api/environment').subscribe(resp => {
            this._current = resp;
            this._afterLoad$.next(resp);
        });
    }

    get current(): WebAppEnvironment {
        return this._current;
    }

    get afterLoad$(): Observable<WebAppEnvironment> {
        return this._afterLoad$.asObservable();
    }

    get isSupportMode() {
        const claims = this._jwt.getRawClaims();
        return claims?.has('SalesRun.Support');
    }

    ngOnDestroy(): void {
        this._afterLoad$.complete();
    }
}